import { Component } from 'js-component-framework';

/**
 * Component for Show More
 */
export default class showMoreSocialMedia extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    if (! this.children.showMoreTrigger || ! this.children.socialMediaCards) {
      return;
    }

    this.setEventListeners();
  }

  setEventListeners() {
    this.children.showMoreTrigger.addEventListener(
      'click',
      this.handleShowMore.bind(this, true)
    );
  }

  handleShowMore() {
    Array.prototype.forEach.call(this.children.socialMediaCards, (item) => {
      item.classList.remove('social-media__hide');
    });
    this.children.showMoreTrigger.style.display = 'none';
  }
}
